import * as React from 'react';

import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import { Button, ClickAwayListener, Popover } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';

import { SocialMediaControls } from './SocialMediaControls';
import styles from './SocialMediaShare.module.css';

export interface SocialMediaShareProps {
  isBlackBackground?: boolean;
  showLabel?: boolean;
  targetURL?: string;
}

export const SocialMediaShare = ({
  isBlackBackground = undefined,
  showLabel = undefined,
  targetURL = undefined,
}: SocialMediaShareProps) => {
  const { T } = useIntl();

  const [popoverAnchorEl, setPopoverAnchorEl] =
    React.useState<HTMLButtonElement>();

  const openPopOver = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) =>
      setPopoverAnchorEl(event.currentTarget),
    [],
  );

  const closePopOver = React.useCallback(
    () => setPopoverAnchorEl(undefined),
    [],
  );

  return (
    <React.Fragment>
      <ClickAwayListener onClickAway={closePopOver}>
        <Button
          variant="text"
          className={isBlackBackground ? styles.blackThemeIcon : ''}
          startIcon={<IosShareOutlinedIcon />}
          onClick={openPopOver}
        >
          {showLabel && T('LBL_SHARE')}
        </Button>
      </ClickAwayListener>
      <Popover
        open={!!popoverAnchorEl}
        anchorEl={popoverAnchorEl}
        onClose={closePopOver}
      >
        <SocialMediaControls targetURL={targetURL} />
      </Popover>
    </React.Fragment>
  );
};
